export default ({ route, redirect, store }) => {
  if (!store.getters['auth/isLoggedIn']) {
    redirect(`/auth?redirect_to=${route.fullPath}`)
  }
  return true
}
